
import "/app/src/modules/zy-crm/components/receipt-workflow/style.module.less?modules";
export default {"allocations": `allocations-vVT_fcyQ`,"summary": `summary-nxevZQHt`,"actions": `actions-mIDGMvG8`,"form": `form-r4lvudWh`,"fields": `fields-6C4hm4Gh`,"wide": `wide-59yzdfwc`}
